import ExcelJS from "exceljs";

const toExcel = (baseUrl, { contact, cards, service, serviceLevels }) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Invoice");

  worksheet.getCell("B1").value = `${(contact.firstName || "").trim()} ${(
    contact.lastName || ""
  ).trim()} Sub`;

  worksheet.getCell("B3").value = "Card";
  worksheet.getCell("B3").font = {
    underline: true,
  };

  worksheet.getCell("C3").value = "Qty";
  worksheet.getCell("C3").font = {
    underline: true,
  };

  worksheet.getCell("D3").value = "Value";
  worksheet.getCell("D3").font = {
    underline: true,
  };

  worksheet.getCell("E3").value = "Service";
  worksheet.getCell("E3").font = {
    underline: true,
  };

  worksheet.getCell("F3").value = "Cost";
  worksheet.getCell("F3").font = {
    underline: true,
  };

  let gradingCost = 0;

  cards.forEach((card, index) => {
    worksheet.getCell(`B${4 + index}`).value = `${(
      card.playerName || ""
    ).trim()} ${(card.setName || "").trim()} ${(
      card.cardNumber || ""
    ).trim()} ${(card.parallel || "").trim()}`.trim();

    worksheet.getCell(`C${4 + index}`).value = card.quantity;

    worksheet.getCell(`D${4 + index}`).value = card.quantity * card.cardValue;

    worksheet.getCell(`D${4 + index}`).numFmt = "$0.00";

    worksheet.getCell(`E${4 + index}`).value = `${service
      .split("-")[0]
      .toUpperCase()} ${serviceLevels[service].label} ${
      serviceLevels[service].description || ""
    }`.trim();

    worksheet.getCell(`F${4 + index}`).value =
      card.quantity * serviceLevels[service].price;

    worksheet.getCell(`F${4 + index}`).numFmt = "$0.00";

    gradingCost = gradingCost + card.quantity * serviceLevels[service].price;
  });

  worksheet.getCell(
    `B${5 + cards.length}`
  ).value = `Insured shipping to/from ${service.split("-")[0].toUpperCase()}`;

  worksheet.getCell(`C${5 + cards.length}`).value = 0;

  worksheet.getCell(`C${5 + cards.length}`).numFmt = "$0.00";

  worksheet.getCell(`B${5 + cards.length + 1}`).value = "Grading";

  worksheet.getCell(`C${5 + cards.length + 1}`).value = gradingCost;

  worksheet.getCell(`C${5 + cards.length + 1}`).numFmt = "$0.00";

  worksheet.getCell(`B${5 + cards.length + 2}`).value = "Total";

  worksheet.getCell(`C${5 + cards.length + 2}`).value = gradingCost;

  worksheet.getCell(`C${5 + cards.length + 2}`).numFmt = "$0.00";

  worksheet.getCell(`B${5 + cards.length + 4}`).value =
    "Not including return shipping to: (please double and triple check that your return address is correct)";

  worksheet.getCell(`B${5 + cards.length + 4}`).font = {
    underline: true,
    bold: true,
  };

  worksheet.getCell(`B${5 + cards.length + 5}`).value = `${(
    contact.firstName || ""
  ).trim()} ${(contact.lastName || "").trim()}`;

  worksheet.getCell(`B${5 + cards.length + 6}`).value = `${(
    contact.address || ""
  ).trim()} ${(contact.address2 || "").trim()}`.trim();

  worksheet.getCell(`B${5 + cards.length + 7}`).value = `${(
    contact.city || ""
  ).trim()}, ${(contact.state || "").trim()} ${(
    contact.zip || ""
  ).trim()}`.trim();

  worksheet.getCell(`B${5 + cards.length + 8}`).value = (
    contact.phoneNumber || ""
  ).trim();

  worksheet.getCell(`B${5 + cards.length + 10}`).value =
    "No Sub Return Cards (see notes below)";

  worksheet.getCell(`B${5 + cards.length + 10}`).font = {
    underline: true,
    bold: true,
  };

  worksheet.getCell(`B${5 + cards.length + 12}`).value = {
    text: `Please click here for important info about your order`,
    hyperlink: `${baseUrl}/terms`,
    tooltip: `${baseUrl}/terms`,
  };

  worksheet.getCell(`B${5 + cards.length + 12}`).font = {
    underline: true,
    bold: true,
    color: { argb: "FF0000FF" },
  };

  return workbook.xlsx.writeBuffer();
};

export default toExcel;
